export default "__VITE_ASSET__90f46072__"